module.exports = __webpack_public_path__ + "img/Personal.9199ddef.svg";